import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProgramSetupAxios } from '../../../API';
import CalendarEventItem from '../../../shared/commonComponents/CalendarEventItem';
import ContentHeading from '../../../shared/commonComponents/ContentHeading';
import authSlice from '../../../store/auth/authSlice';
import ProgramSchedule from '../../../pages/onboarding/subComp/ProgramSchedule';

const Calendar = () => {
    const dispatch = useDispatch();
    const missionDetails = useSelector((state) => state.auth.missionDetails);
    const userDetails = useSelector((state) => state.auth.loggedInUser);
    const [tasks, setTasks] = useState([]);

    // const updateMIssionDetails = () => {
    //     ProgramSetupAxios.get('OfferingMission/getmissionbyid/' + userDetails.missionId + "/" + userDetails.offeringUserId)
    //         .then(function (missionReponse) {
    //             dispatch(authSlice.actions.setMissionDetails(missionReponse.data));
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }

    useEffect(() => {
        // sort missionDetails.tasks by activityStartDate and then by sequence and id in descending order
        let data = [...missionDetails.tasks] || [];
        const sortedTasks = data.sort((a, b) => {
            if (a.activityStartDate < b.activityStartDate) { return -1; }
            if (a.activityStartDate > b.activityStartDate) { return 1; }
            if (a.sequence < b.sequence) { return -1; }
            if (a.sequence > b.sequence) { return 1; }
            if (a.id < b.id) { return -1; }
            if (a.id > b.id) { return 1; }
            return 0;
        });


        if (window.location.href.includes('scdxexplore')) {
            console.log("sortedTasks", sortedTasks);
        }

        setTasks(sortedTasks);
    }, [missionDetails]);

    return (
        <div className="px-3 py-4 content scroll-content">
            <ContentHeading title="Activities in this Journey" />
            <div className="event-item-wrapper">
                {tasks.map(item => {
                    return <CalendarEventItem item={item} key={"event-item" + item.activityId} />;
                })}
            </div>
        </div>
    );
};

export default Calendar;